(function () {
  'use strict';

  var scheduled = false;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function bindNativeChat() {
    var launcher = document.getElementById('nailhandy-chat-launcher');
    var panel = document.getElementById('nailhandy-chat-panel');
    var backdrop = document.getElementById('nailhandy-chat-backdrop');
    if (!launcher || !panel || !backdrop) return;

    function openChat() {
      panel.hidden = false;
      backdrop.hidden = false;
      document.body.classList.add('nailhandy-native-chat-open');
      launcher.setAttribute('aria-expanded', 'true');
      window.setTimeout(function () {
        var field = panel.querySelector('input, textarea, button');
        if (field) field.focus({ preventScroll: true });
      }, 0);
    }

    function closeChat() {
      panel.hidden = true;
      backdrop.hidden = true;
      document.body.classList.remove('nailhandy-native-chat-open');
      launcher.setAttribute('aria-expanded', 'false');
      launcher.focus({ preventScroll: true });
    }

    launcher.addEventListener('click', openChat);
    backdrop.addEventListener('click', closeChat);
    panel.querySelector('[data-nailhandy-chat-close]').addEventListener('click', closeChat);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) closeChat();
    });
  }

  function isVisible(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function updateCollisionState() {
    scheduled = false;
    var body = document.body;
    if (!body) return;

    var cartDrawer = document.querySelector('cart-drawer.active, cart-drawer.animate, cart-drawer[open], .cart-drawer.active, .cart-drawer.is-open');
    body.classList.toggle('nailhandy-cart-open', Boolean(cartDrawer && isVisible(cartDrawer)));

    var purchaseControls = document.querySelectorAll(
      '.sticky-atc, button[name="checkout"], a[href*="/checkout"], .shopify-payment-button, .product-form__submit'
    );
    var purchaseVisible = Array.prototype.some.call(purchaseControls, function (element) {
      if (!isVisible(element)) return false;
      var rect = element.getBoundingClientRect();
      return rect.bottom >= window.innerHeight - 180 && rect.top <= window.innerHeight;
    });
    body.classList.toggle('nailhandy-purchase-ui-visible', purchaseVisible);
  }

  function scheduleCollisionUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateCollisionState);
  }

  ready(function () {
    bindNativeChat();

    scheduleCollisionUpdate();
    window.addEventListener('scroll', scheduleCollisionUpdate, { passive: true });
    window.addEventListener('resize', scheduleCollisionUpdate, { passive: true });
    var cartDrawer = document.querySelector('cart-drawer, .cart-drawer');
    if (cartDrawer) {
      new MutationObserver(scheduleCollisionUpdate).observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['class', 'open', 'aria-hidden']
      });
    }
  });
})();
